import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgFiSmile({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 16 16"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.00002 1.99984C4.68631 1.99984 2.00002 4.68613 2.00002 7.99984C2.00002 11.3135 4.68631 13.9998 8.00002 13.9998C11.3137 13.9998 14 11.3135 14 7.99984C14 4.68613 11.3137 1.99984 8.00002 1.99984ZM0.666687 7.99984C0.666687 3.94975 3.94993 0.666504 8.00002 0.666504C12.0501 0.666504 15.3334 3.94975 15.3334 7.99984C15.3334 12.0499 12.0501 15.3332 8.00002 15.3332C3.94993 15.3332 0.666687 12.0499 0.666687 7.99984Z"
				fill={finalColor}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.86457 8.93043C5.64312 8.63828 5.22696 8.57966 4.93333 8.79988C4.63878 9.02079 4.57908 9.43866 4.8 9.73321L5.33333 9.33321C4.8 9.73321 4.80016 9.73342 4.80032 9.73364L4.80067 9.73411L4.80144 9.73513L4.80327 9.73754L4.80807 9.74382L4.82227 9.76199C4.83377 9.7765 4.84934 9.79576 4.86891 9.81908C4.908 9.86567 4.96333 9.92876 5.0343 10.0028C5.17568 10.1503 5.38229 10.3447 5.64955 10.539C6.18151 10.9259 6.98298 11.3332 8 11.3332C9.01702 11.3332 9.81849 10.9259 10.3504 10.539C10.6177 10.3447 10.8243 10.1503 10.9657 10.0028C11.0367 9.92876 11.092 9.86567 11.1311 9.81908C11.1507 9.79576 11.1662 9.7765 11.1777 9.76199L11.1919 9.74382L11.1967 9.73754L11.1986 9.73513L11.1993 9.73411L11.1997 9.73364C11.1998 9.73342 11.2 9.73321 10.6667 9.33321L11.2 9.73321C11.4209 9.43866 11.3612 9.02079 11.0667 8.79988C10.773 8.57966 10.3569 8.63828 10.1354 8.93043L10.1323 8.93438C10.1284 8.93939 10.1208 8.94878 10.1098 8.96192C10.0877 8.98825 10.0519 9.02933 10.003 9.08027C9.90485 9.18274 9.75729 9.32176 9.56622 9.46072C9.18151 9.74051 8.64964 9.99988 8 9.99988C7.35035 9.99988 6.81849 9.74051 6.43378 9.46072C6.24271 9.32176 6.09515 9.18274 5.99695 9.08027C5.94812 9.02933 5.91231 8.98825 5.89021 8.96192C5.87918 8.94878 5.87163 8.93939 5.86767 8.93438L5.86457 8.93043Z"
				fill={finalColor}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.33331 6.00016C5.33331 5.63197 5.63179 5.3335 5.99998 5.3335H6.00665C6.37484 5.3335 6.67331 5.63197 6.67331 6.00016C6.67331 6.36835 6.37484 6.66683 6.00665 6.66683H5.99998C5.63179 6.66683 5.33331 6.36835 5.33331 6.00016Z"
				fill={finalColor}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.33331 6.00016C9.33331 5.63197 9.63179 5.3335 9.99998 5.3335H10.0066C10.3748 5.3335 10.6733 5.63197 10.6733 6.00016C10.6733 6.36835 10.3748 6.66683 10.0066 6.66683H9.99998C9.63179 6.66683 9.33331 6.36835 9.33331 6.00016Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgFiSmile;
